<template>
  <key-value-suggest
    :value="value"
    v-on:input="onInput"
    v-bind="$attrs"
    :data="users"
    keyProperty="id"
    :valueProperty="formatValue"
  ></key-value-suggest>
</template>
<script>
import { computed, ref, watch } from '@vue/composition-api'
import KeyValueSuggest from './KeyValueSuggest.vue'
// Note the use of the props: value: This is necessary to facilitate the interaction of
// the parents v-model which sets the value in the child, and is set by the emit of
// the 'input' event.
export default {
  inheritAttrs: false,
  components: { KeyValueSuggest },
  props: {
    value: {
      type: String
    },
    users: {
      type: Array,
      required: true
    },
  },
  setup(props, context) {
    function formatValue(item) {
      return item['lastName'] + ', ' + item['firstName']
    }
    function onInput(e) {
      // console.log('us: onInput')
      context.emit('input', e)
    }
    return {
      formatValue,
      onInput
    }
  }
}
</script>
<style lang="scss">
</style>